import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { log } from '../../services/utils';

import PaginationButton from './PaginationButton';
import PageSelector from './PageSelector';
import PageSizeControl from './PageSizeControl';

import styles from './table.module.css';

const TableFooter = ( {
	canNextPage,
	canPreviousPage,
	gotoPage,
	isLoading,
	nextPage,
	noRecords,
	pageCount,
	pageIndex,
	pageSize,
	previousPage,
	setPageSize
} ) => {
	return (
		<div className={ `${ styles.tableFooter } ${ noRecords || isLoading ? styles.disabledFooterUI : '' }` }>
			{ log( '- tableFooter' ) }
			<PaginationButton
				content="Previous"
				disabled={ isLoading || !canPreviousPage }
				onClick={ previousPage }
			/>
			<PageSelector
				gotoPage={ gotoPage }
				pageCount={ noRecords || isLoading
					? '0'
					: pageCount
				}
				value={ noRecords || isLoading
					? '0'
					: `${ pageIndex + 1 }`
				}
			/>
			<PageSizeControl
				pageSize={ pageSize }
				setPageSize={ setPageSize }
			/>
			<PaginationButton
				content="Next"
				disabled={ isLoading || !canNextPage }
				onClick={ nextPage }
			/>
		</div>
	);
};

TableFooter.propTypes = {
	canNextPage: PropTypes.bool.isRequired,
	canPreviousPage: PropTypes.bool.isRequired,
	gotoPage: PropTypes.func.isRequired,
	isLoading: PropTypes.bool,
	nextPage: PropTypes.func.isRequired,
	noRecords: PropTypes.bool.isRequired,
	pageCount: PropTypes.number.isRequired,
	pageIndex: PropTypes.number.isRequired,
	pageSize: PropTypes.number.isRequired,
	previousPage: PropTypes.func.isRequired,
	setPageSize: PropTypes.func.isRequired
};

export default memo( TableFooter );
